// extracted by mini-css-extract-plugin
export default {"tutorialWrapper2":"css_tutorialWrapper2__Gfkw9"};